
  import createMeisterIcons from '../src/createMeisterIcons';

  const Search = createMeisterIcons("search", [["path",{"fill":"currentColor","d":"M4.3 11.55a7.25 7.25 0 1 1 14.5 0 7.25 7.25 0 0 1-14.5 0m7.25-8.75a8.75 8.75 0 1 0 5.634 15.445l2.736 2.735a.75.75 0 1 0 1.06-1.06l-2.735-2.736A8.75 8.75 0 0 0 11.55 2.8","key":"784f96ef4d52e02ae7400e04eb2ad9798015debb","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default Search
  